import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './billing.reducer'
import * as state from './billing.state'

export const billingState = createFeatureSelector<state.State>('billing')

export const selectBillingLoaded = createSelector(billingState, (s: state.State) => s.isLoaded)

export const selectAllBillings = createSelector(billingState, reducer.selectAll)
